
function TextButton({ className, fontSize, onClick, children }) {
    const styles = {
        fontSize: fontSize || '11px',
        cursor: 'pointer',
        color: '#fff'
    };
    return (
        <b className={`${className}`} style={styles} onClick={onClick}>
            {children}
        </b>
    )
}

export default TextButton